import React, { useState, useEffect } from 'react';
import {
  KTSVG,
  LoadingGrid,
  SimpleAlert,
  TableList,
} from '../../../../rbts/helpers';
import { useObtenerEventos } from '../hooks/EventosHook';
import { ModalCRU } from '../_modals/ModalCRU';
import { MenuComponent } from '../../../../rbts/assets/ts/components';
import Swal from 'sweetalert2';
import { estatusEventoService } from '../../../service/eventos/Eventos';
import { useSelectGeneric } from '../../catalogos/generico/hooks/genericoHook';

type Props = {};

const View: React.FC<Props> = ({}) => {
  const [reload, setReload] = useState<number>(Math.random() * 40);
  const { list, loading } = useObtenerEventos(reload);
  const [showNoteModal, setShowNoteModal] = useState<boolean>(false);
  const [register, setRegister] = useState<number>(0);
  const { catalog: estatusList } = useSelectGeneric('STS_EVENT');

  const openModal = (isOpen: boolean) => {
    setShowNoteModal(isOpen);
  };

  const dropdownRender = (row: any) => {
    return (
      <>
        <div className="d-flex justify-content-end flex-shrink-0">
          <div
            data-kt-menu="true"
            className="btn btn-light btn-active-light-primary btn-sm"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
          >
            Acciones
            <span className="svg-icon svg-icon-5 m-0">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mh-50px"
              >
                <path
                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
          </div>
          <div
            className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
            data-kt-menu="true"
          >
            <div className="menu-item px-3">
              <div
                className="menu-link px-3"
                onClick={() => {
                  editRegister(row.id);
                }}
              >
                Editar
              </div>
              {row.status && (
                <>
                  {row.status.code === 'PEND' && (
                    <div
                      className="menu-link px-3"
                      data-kt-users-table-filter="delete_row"
                      onClick={() => {
                        activarEvento(row.id);
                      }}
                    >
                      Activar
                    </div>
                  )}
                  {row.status.code === 'ACTIVE' && (
                    <div
                      className="menu-link px-3"
                      data-kt-users-table-filter="delete_row"
                      onClick={() => {
                        finalizarEvento(row.id);
                      }}
                    >
                      Finalizar
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const columns: any = [
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Nombre</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => (
        <>
          <span className="fw-bolder ">{row.nombre}</span>
        </>
      ),
      sortable: true,
      width: '60%',
    },
    {
      id: 'fecha_inicio',
      name: <div className="fw-bolder text-muted me-5">Fecha inicio</div>,
      selector: (row: any) =>
        row.fecha_inicio
          ? new Date(row.fecha_inicio).toISOString().split('T')[0]
          : '',
      cell: (row: any) => (
        <>
          <span className="">
            {row.fecha_inicio
              ? new Date(row.fecha_inicio).toISOString().split('T')[0]
              : ''}
          </span>
        </>
      ),
      sortable: true,
      width: '10%',
    },
    {
      id: 'fecha_fin',
      name: <div className="fw-bolder text-muted me-5">Fecha fin</div>,
      selector: (row: any) =>
        row.fecha_fin
          ? new Date(row.fecha_fin).toISOString().split('T')[0]
          : '',
      cell: (row: any) => (
        <>
          <span className="">
            {row.fecha_fin
              ? new Date(row.fecha_fin).toISOString().split('T')[0]
              : ''}
          </span>
        </>
      ),
      sortable: true,
      width: '10%',
    },
    {
      id: 'estatus',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      selector: (row: any) => (row.status ? row.status.name : ''),
      cell: (row: any) => (
        <>
          {row.status && (
            <>
              {row.status.code === 'PEND' && (
                <span className="badge badge-light-primary  text-hover-primary fw-bold px-4 py-3 cursor-pointer">
                  {row.status.name}
                </span>
              )}
              {row.status.code === 'ACTIVE' && (
                <span className="badge badge-light-success  text-hover-success fw-bold px-4 py-3 cursor-pointer">
                  {row.status.name}
                </span>
              )}
              {row.status.code === 'FINISH' && (
                <span className="badge badge-light-danger  text-hover-danger fw-bold px-4 py-3">
                  {row.status.name}
                </span>
              )}
            </>
          )}
        </>
      ),
      sortable: true,
      width: '10%',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted me-5"></div>,
      selector: (row: any) => (row.status ? row.status.name : ''),
      cell: (row: any) => (
        <>
          {row.status && (
            <>
              {(row.status.code === 'PEND' || row.status.code === 'ACTIVE') && (
                <>{dropdownRender(row)}</>
              )}
            </>
          )}
        </>
      ),
      sortable: false,
      width: '10%',
    },
  ];

  const editRegister = (id: number) => {
    setRegister(id);
    setShowNoteModal(!showNoteModal);
  };

  const activarEvento = (id: number) => {
    Swal.fire({
      title: '¿Desea activar el evento?',
      html: `
      <div className="text-gray-600">
        Si confirma esta acción toda operación se relacionará a este evento.
      </div>
      `,
      showCancelButton: true,
      padding: '1em',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-light me-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let estatus = estatusList.find(
            (estatus) => estatus.code === 'ACTIVE'
          );
          if (estatus) {
            const { id: estatus_id } = estatus;
            await estatusEventoService(id, estatus_id);
            window.location.reload();
          }
        } catch (error: any) {
          if (error && error.response) {
            const { message } = error.response.data;
            SimpleAlert(message, 3000, 'error');
          }
        }
      }
    });
  };
  const finalizarEvento = (id: number) => {
    Swal.fire({
      title: '¿Desea finalizar el evento?',
      html: `
      <div className="text-gray-600">
        Si confirma esta acción el evento se finalizará y no se podrá activar.
      </div>
      `,
      showCancelButton: true,
      padding: '1em',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      reverseButtons: true,
      customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-light me-3',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let estatus = estatusList.find(
            (estatus) => estatus.code === 'FINISH'
          );
          if (estatus) {
            const { id: estatus_id } = estatus;
            await estatusEventoService(id, estatus_id);
            window.location.reload();
          }
        } catch (error: any) {
          if (error && error.response) {
            const { message } = error.response.data;
            SimpleAlert(message, 3000, 'error');
          }
        }
      }
    });
  };

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [loading]);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="flex-lg-row-fluid">
            <div className={`card card-xxl-stretch mb-xl-12`}>
              <div className="card-header border-0 pt-5 mt-4 d-flex">
                <div className="card-title align-items-start flex-column flex-grow-1"></div>
                <div className="text-end">
                  <button
                    type="button"
                    title="Nueva venta"
                    onClick={() => {
                      openModal(true);
                    }}
                    className={`btn btn-primary`}
                  >
                    <span className="indicator-label">Nuevo evento</span>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row gy-5 g-xl-8">
                  <div className="col-xl-12">
                    {loading ? (
                      <LoadingGrid text="Cargando..."></LoadingGrid>
                    ) : (
                      <TableList data={list} columns={columns}></TableList>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalCRU
        show={showNoteModal}
        handleClose={(refresh) => {
          setShowNoteModal(!showNoteModal);
          setRegister(0);
          if (refresh) {
            setReload(Math.random() * 40);
          }
        }}
        id={register}
      ></ModalCRU>
    </>
  );
};

export { View };
